import { AlertModelService } from '../alert-model.service';

export class AlertReporterHelper {
  static summaryText(service: AlertModelService): string {
    let summary = '';
    const name = service.callCenterReporter?.name;
    if (name) {
      if (name.familyName) summary = name.familyName;
      if (name.givenName) {
        if (summary.length) summary += ', ';
        summary += name.givenName;
      }
    }
    if (service.mapLocation?.assetName) {
      summary += ' (' + service.mapLocation?.assetName + ')';
    }
    return summary;
  }
}
